import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  //  language: null,
  sortby: null,
  deviceTab: 0,
  wrapperSize: 0,
  enableSound: null,
  isMobile: /Mobi|Android/i.test(navigator.userAgent),
  sessionExpired: false,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
